import React from 'react';
import { Calendar, Clock } from 'lucide-react';
import { colors } from '../../styles/theme';

interface ArticleHeaderProps {
  category: string;
  date: string;
  readTime: string;
}

const ArticleHeader: React.FC<ArticleHeaderProps> = ({ category, date, readTime }) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <span 
        className="px-3 py-1 rounded-full text-sm font-medium"
        style={{
          backgroundColor: `${colors.primary}15`,
          color: colors.primary
        }}
      >
        {category}
      </span>
      <div className="flex items-center space-x-4 text-gray-500 text-sm">
        <span className="flex items-center">
          <Calendar className="w-4 h-4 mr-1" />
          {date}
        </span>
        <span className="flex items-center">
          <Clock className="w-4 h-4 mr-1" />
          {readTime} de lecture
        </span>
      </div>
    </div>
  );
};

export default ArticleHeader;